export default "__VITE_ASSET__CF7CdLNu__"